
import { Calendar, Clock, User } from "lucide-react";
import { formatDate } from "@/lib/blogUtils";

interface BlogPostMetadataProps {
  author: {
    name: string;
    avatar?: string;
  };
  date: string;
  readingTime: string;
}

export const BlogPostMetadata = ({ author, date, readingTime }: BlogPostMetadataProps) => {
  return (
    <div className="flex flex-wrap items-center gap-6 text-muted-foreground mb-6">
      <div className="flex items-center">
        <div className="h-8 w-8 rounded-full overflow-hidden mr-2">
          <img 
            src={author.avatar || "https://randomuser.me/api/portraits/men/1.jpg"} 
            alt={author.name} 
            className="h-full w-full object-cover"
          />
        </div>
        <span>{author.name}</span>
      </div>
      
      <div className="flex items-center">
        <Calendar className="h-4 w-4 mr-1.5" />
        <span>{date ? formatDate(date) : ""}</span>
      </div>
      
      <div className="flex items-center">
        <Clock className="h-4 w-4 mr-1.5" />
        <span>{readingTime}</span>
      </div>
    </div>
  );
};
